import * as React from "react";

function SvgPage(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M13.5 0A2.5 2.5 0 0116 2.5v13c0 .18-.097.345-.253.433a.491.491 0 01-.507 0L13 14.6l-2.24 1.333a.517.517 0 01-.52-.006L8 14.593l-2.24 1.334c-.159.1-.361.1-.52 0L3 14.593.76 15.927a.496.496 0 01-.507 0A.501.501 0 010 15.5v-13A2.5 2.5 0 012.5 0h11zm0 1h-11A1.5 1.5 0 001 2.5v12.12l1.74-1.047c.159-.1.361-.1.52 0l2.24 1.334 2.24-1.334A.528.528 0 018 13.5a.528.528 0 01.26.073l2.24 1.334 2.24-1.334c.159-.1.361-.1.52 0L15 14.62V2.5A1.5 1.5 0 0013.5 1zm-5 9a.5.5 0 010 1h-5a.5.5 0 110-1h5zm4 0a.5.5 0 010 1h-1a.5.5 0 110-1h1zm-4-3a.5.5 0 110 1h-5a.5.5 0 010-1h5zm4 0a.5.5 0 110 1h-1a.5.5 0 010-1h1zm-4-3a.5.5 0 110 1h-5a.5.5 0 010-1h5zm4 0a.5.5 0 110 1h-1a.5.5 0 010-1h1z"
        fill="#22CDDB"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgPage;
